import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, unref as _unref, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "manager-residency-requests__list-wrapper" }
const _hoisted_2 = { class: "manager-residency-requests__action-bar" }
const _hoisted_3 = { class: "manager-residency-requests__table-wrapper personal-area-table-wrapper" }
const _hoisted_4 = {
  key: 0,
  class: "manager-residency-requests__list--empty"
}
const _hoisted_5 = { class: "manager-residency-requests__list--empty-title" }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = {
  key: 0,
  class: "manager-residency-requests__list--empty-description"
}
const _hoisted_8 = { class: "request-filter-drawer__close-trigger" }
const _hoisted_9 = { class: "manager-residency-requests__filter-fields-wrapper" }
const _hoisted_10 = { class: "manager-residency-requests__filter-fields-section" }

import { computed, ref } from 'vue';
import DataTable from 'primevue/datatable';
import Column from 'primevue/column';
import type { FiltersListResponse, ApiStatus, RawApplication } from '../types';
import { CloseOutlined } from '@ant-design/icons-vue';
import SearchInput from '../../SearchInput.vue';
import Pagination from '../../Pagination.vue';
import FilterIcon from '@/js/components/icons/FilterIcon.vue';
import {
  Drawer as ADrawer,
  Form as AForm,
  FormItem as AFormItem,
  Select as ASelect,
  DatePicker as ADatePicker,
  Row as ARow,
  Col as ACol,
  Space as ASpace,
  ConfigProvider as AConfigProvider,
} from 'ant-design-vue';
import dayjs, { type Dayjs } from 'dayjs';
import ruRU from 'ant-design-vue/es/locale/ru_RU';


export default /*@__PURE__*/_defineComponent({
  __name: 'RequestsList',
  props: {
    requests: {},
    pagination: {},
    loading: { type: Boolean },
    filter: {}
  },
  emits: ["row-click", "params-change", "export-click"],
  setup(__props: any, { emit: __emit }) {

const ARangePicker = ADatePicker.RangePicker;

const props = __props;

const emit = __emit;

const columns = [
  {
    field: 'id',
    header: '#',
    render: (data: RawApplication) => data.id,
    cellClass: null,
  },
  {
    field: 'createdAt',
    header: 'Дата поступления',
    render: (data: RawApplication) => dayjs(data.createdAt).format('DD.MM.YYYY / HH:mm'),
    cellClass: null,
  },
  {
    field: 'companyName',
    header: 'Компания',
    render: (data: RawApplication) => data.companyName || '',
    cellClass: null,
  },
  {
    field: 'fio',
    header: 'Контактное лицо',
    render: (data: RawApplication) => data.fio || '',
    cellClass: null,
  },
  {
    field: 'phone',
    header: 'Телефон',
    render: (data: RawApplication) => data.phone || '',
    cellClass: null,
  },
  {
    field: 'email',
    header: 'Почта',
    render: (data: RawApplication) => data.email || '',
    cellClass: null,
  },
  {
    field: 'businessArea',
    header: 'Сфера деятельности',
    render: (data: RawApplication) => data.businessArea || '',
    cellClass: null,
  },
  {
    field: 'rentalProperty',
    header: 'Объект аренды',
    render: (data: RawApplication) => data.rentalProperty || '',
    cellClass: null,
  },
  {
    field: 'dateEvent',
    header: 'Желаемая дата мероприятия',
    render: (data: RawApplication) => dayjs(data.dateEvent).format('DD.MM.YYYY / HH:mm'),
    cellClass: null,
  },
  {
    field: 'educationType',
    header: 'Вид образовательной деятельности',
    render: (data: RawApplication) => data.educationType || '',
    cellClass: null,
  },
  {
    field: 'status',
    header: 'Статус',
    render: (data: RawApplication) => data.status.name,
    cellClass: (data: RawApplication) => getStatusClass(data.status.id),
  },
] as const;

const filterOpen = ref(false);
const filter = ref<
  Partial<Record<keyof FiltersListResponse, string | ApiStatus>> & {
    dateFrom: string | null;
    dateTo: string | null;
  }
>({
  status: '',
  dateFrom: null,
  dateTo: null,
  businessArea: '',
  rentalProperty: '',
  cluster: '',
  educationType: '',
});
const search = ref('');
const dateRange = ref<[Dayjs, Dayjs] | undefined>(undefined);

const isFilterApplied = computed(() => {
  return Boolean(
    filter.value.status ||
    filter.value.dateFrom ||
    filter.value.dateTo ||
    filter.value.businessArea ||
    filter.value.rentalProperty ||
    filter.value.cluster ||
    filter.value.educationType,
  );
});

const emptyState = computed(() => {
  const hasSearch = search.value.trim().length > 0;

  if (hasSearch && isFilterApplied.value) {
    return {
      title: `0 результатов для `,
      description: 'Измените параметры поиска или фильтра.',
    };
  }

  if (hasSearch) {
    return {
      title: `0 совпадений для `,
      description: 'Проверьте орфографию или измените запрос.',
    };
  }

  if (isFilterApplied.value) {
    return {
      title: '0 результатов',
      description: 'Измените значения в фильтре.',
    };
  }

  return {
    title: 'Нет поступивших заявок',
    description: '',
  };
});

const visibleColumns = computed(() => {
  const firstRow = props.requests?.[0];

  if (!firstRow) {
    return columns;
  }

  return columns.filter((column) => Object.prototype.hasOwnProperty.call(firstRow, column.field));
});

const hasFilterField = (key: keyof FiltersListResponse) => {
  return Object.prototype.hasOwnProperty.call(props.filter, key);
};

const currentPageProxy = computed({
  get: () => props.pagination.currentPage,
  set: (val: number) => {
    emit('params-change', {
      page: val,
      filter: filter.value,
      search: search.value,
    });
  },
});

const statusOptions = computed(() =>
  props.filter.status?.map((item) => ({
    value: item.id,
    label: item.name,
  })),
);

const businessAreaOptions = computed(() =>
  hasFilterField('businessArea')
    ? props.filter.businessArea?.map((item) => ({
      value: item.id,
      label: item.text,
    }))
    : [],
);

const rentalPropertyOptions = computed(() =>
  hasFilterField('rentalProperty')
    ? props.filter.rentalProperty?.map((item) => ({
      value: item.id,
      label: item.name,
    }))
    : [],
);

const clusterOptions = computed(() =>
  hasFilterField('cluster')
    ? props.filter.cluster?.map((item) => ({
      value: item.id,
      label: item.name,
    }))
    : [],
);

const typeEducationOptions = computed(() =>
  hasFilterField('educationType')
    ? props.filter.educationType?.map((item) => ({
      value: item.id,
      label: item.text,
    }))
    : [],
);

function handleSearch(value: string) {
  emit('params-change', { page: 1, filter: filter.value, search: value });
}

function applyFilters() {
  if (dateRange.value) {
    filter.value.dateFrom = dateRange.value[0].format('YYYY-MM-DD');
    filter.value.dateTo = dateRange.value[1].format('YYYY-MM-DD');
  } else {
    filter.value.dateFrom = null;
    filter.value.dateTo = null;
  }

  filterOpen.value = false;

  emit('params-change', {
    page: 1,
    filter: { ...filter.value },
    search: search.value,
  });
}

function resetFilters() {
  dateRange.value = undefined;

  filter.value = {
    status: '',
    dateFrom: null,
    dateTo: null,
    businessArea: '',
    rentalProperty: '',
    cluster: '',
    educationType: '',
  };

  filterOpen.value = false;

  emit('params-change', {
    page: 1,
    filter: { ...filter.value },
    search: search.value,
  });
}

function handlePageChange(page: number) {
  emit('params-change', { page: page, filter: filter.value, search: search.value });
}

function onRowClick(event: any) {
  const data = event.data;
  emit('row-click', data);
}

function onExportClick() {
  emit('export-click', { filter: filter.value, search: search.value });
}

function getRequestRowClass(request: RawApplication, noWrap?: boolean) {
  const baseClass = 'personal-area-table__cell-content';
  const newStatusClass =
    request.status.code === 'new' ? ' personal-area-table__cell-content--new' : '';
  const noWrapClass = noWrap ? ' personal-area-table__cell-content--nowrap' : '';
  return baseClass + newStatusClass + noWrapClass;
}

const getRowClass = (data: RawApplication) => ({
  'personal-area-table__row-new': data.status.code === 'new',
});

function getStatusClass(status: ApiStatus | null): string {
  return `personal-area-table__status personal-area-table__status--${String(status)
    .toString()
    .toLowerCase()
    .replace(/\s+/g, '-')}`;
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _cache[13] || (_cache[13] = _createElementVNode("div", { class: "manager-residency-requests__header" }, [
        _createElementVNode("h2", { class: "manager-residency-requests__title" }, "Заявки")
      ], -1)),
      _createElementVNode("div", _hoisted_2, [
        _createVNode(SearchInput, {
          modelValue: search.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((search).value = $event)),
          placeholder: "Найти...",
          onSearch: handleSearch
        }, null, 8, ["modelValue"]),
        _createElementVNode("button", {
          type: "button",
          class: "btn btn-secondary btn-medium manager-residency-requests__filter",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (filterOpen.value = true))
        }, [
          _createVNode(FilterIcon, { filled: isFilterApplied.value }, null, 8, ["filled"]),
          _cache[10] || (_cache[10] = _createElementVNode("span", null, "Фильтр", -1))
        ]),
        _createElementVNode("button", {
          type: "button",
          class: "btn btn-secondary btn-medium manager-residency-requests__save-all",
          onClick: onExportClick
        }, [...(_cache[11] || (_cache[11] = [
          _createTextVNode(" Скачать заявки ", -1),
          _createElementVNode("span", { class: "manager-residency-requests__button-note" }, "(.xls)", -1)
        ]))])
      ]),
      _createElementVNode("div", _hoisted_3, [
        (props.requests.length === 0 && !__props.loading)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createTextVNode(_toDisplayString(emptyState.value.title) + " ", 1),
                (search.value.length > 0)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_6, "«" + _toDisplayString(search.value) + "»", 1))
                  : _createCommentVNode("", true)
              ]),
              (emptyState.value.description)
                ? (_openBlock(), _createElementBlock("div", _hoisted_7, _toDisplayString(emptyState.value.description), 1))
                : _createCommentVNode("", true)
            ]))
          : (_openBlock(), _createBlock(_unref(DataTable), {
              key: 1,
              loading: __props.loading,
              value: props.requests,
              onRowClick: onRowClick,
              dataKey: "id",
              selectionMode: "single",
              tableStyle: "min-width: 70rem",
              scrollable: "",
              scrollHeight: "600px",
              rowClass: getRowClass
            }, {
              loading: _withCtx(() => [...(_cache[12] || (_cache[12] = [
                _createElementVNode("div", { class: "manager-residency-requests__loading" }, [
                  _createElementVNode("i", {
                    class: "pi pi-spinner pi-spin",
                    style: {"font-size":"2rem"}
                  }),
                  _createElementVNode("span", null, "Загрузка...")
                ], -1)
              ]))]),
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(visibleColumns.value, (column) => {
                  return (_openBlock(), _createBlock(_unref(Column), {
                    key: column.field,
                    header: column.header
                  }, {
                    body: _withCtx(({ data }) => [
                      (column.field === 'educationType')
                        ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(data.educationType, (item) => {
                            return (_openBlock(), _createElementBlock("p", {
                              key: item,
                              class: _normalizeClass(getRequestRowClass(data, true))
                            }, _toDisplayString(item), 3))
                          }), 128))
                        : (_openBlock(), _createElementBlock("span", {
                            key: 1,
                            class: _normalizeClass(column.cellClass?.(data) ?? getRequestRowClass(data, true))
                          }, _toDisplayString(column.render(data)), 3))
                    ]),
                    _: 2
                  }, 1032, ["header"]))
                }), 128))
              ]),
              _: 1
            }, 8, ["loading", "value"]))
      ]),
      _createVNode(Pagination, {
        modelValue: currentPageProxy.value,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((currentPageProxy).value = $event)),
        "total-count": __props.pagination.totalCount,
        "page-size": __props.pagination.pageSize,
        onChange: handlePageChange
      }, null, 8, ["modelValue", "total-count", "page-size"])
    ]),
    _createVNode(_unref(ADrawer), {
      width: 800,
      open: filterOpen.value,
      class: "request-filter-drawer",
      "body-style": { paddingBottom: '24px' },
      "footer-style": { textAlign: 'left' },
      onClose: _cache[9] || (_cache[9] = ($event: any) => (filterOpen.value = false))
    }, {
      title: _withCtx(() => [...(_cache[14] || (_cache[14] = [
        _createElementVNode("div", { class: "request-filter-drawer__header-shell" }, [
          _createElementVNode("div", { class: "request-filter-drawer__header-overline" }, "Фильтр")
        ], -1)
      ]))]),
      closeIcon: _withCtx(() => [
        _createElementVNode("span", _hoisted_8, [
          _createVNode(_unref(CloseOutlined))
        ])
      ]),
      footer: _withCtx(() => [
        _createVNode(_unref(ARow), {
          align: "middle",
          justify: "end",
          class: "request-filter-drawer__toolbar"
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(ACol), null, {
              default: _withCtx(() => [
                _createVNode(_unref(ASpace), null, {
                  default: _withCtx(() => [
                    _createElementVNode("button", {
                      type: "button",
                      class: "btn btn-outline",
                      onClick: resetFilters
                    }, "Сбросить"),
                    _createElementVNode("button", {
                      type: "button",
                      class: "btn btn-primary",
                      onClick: applyFilters
                    }, "Применить")
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      default: _withCtx(() => [
        _createVNode(_unref(AForm), { layout: "vertical" }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_9, [
              _createVNode(_unref(AFormItem), {
                label: "Статус",
                class: "stc-ant-field-skin"
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(ASelect), {
                    value: filter.value.status,
                    "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((filter.value.status) = $event)),
                    placeholder: "Статус",
                    options: statusOptions.value
                  }, null, 8, ["value", "options"])
                ]),
                _: 1
              }),
              _createVNode(_unref(AFormItem), {
                label: "Диапазон поступления",
                class: "stc-ant-field-skin"
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(AConfigProvider), { locale: _unref(ruRU) }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(ARangePicker), {
                        value: dateRange.value,
                        "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((dateRange).value = $event)),
                        style: {"width":"100%"},
                        format: "DD.MM.YYYY",
                        placeholder: ['дд.мм.гггг', 'дд.мм.гггг']
                      }, {
                        separator: _withCtx(() => [...(_cache[15] || (_cache[15] = [
                          _createTextVNode("-", -1)
                        ]))]),
                        suffixIcon: _withCtx(() => [...(_cache[16] || (_cache[16] = [
                          _createElementVNode("img", {
                            src: "/assets/images/icons/range-picker-icon.svg",
                            alt: ""
                          }, null, -1)
                        ]))]),
                        _: 1
                      }, 8, ["value"])
                    ]),
                    _: 1
                  }, 8, ["locale"])
                ]),
                _: 1
              })
            ]),
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("div", null, [
                (hasFilterField('businessArea'))
                  ? (_openBlock(), _createBlock(_unref(AFormItem), {
                      key: 0,
                      label: "Сфера деятельности",
                      class: "stc-ant-field-skin"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_unref(ASelect), {
                          value: filter.value.businessArea,
                          "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((filter.value.businessArea) = $event)),
                          placeholder: "Сфера деятельности",
                          options: businessAreaOptions.value
                        }, null, 8, ["value", "options"])
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
              ]),
              (hasFilterField('rentalProperty'))
                ? (_openBlock(), _createBlock(_unref(AFormItem), {
                    key: 0,
                    label: "Объект аренды",
                    class: "stc-ant-field-skin"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(ASelect), {
                        value: filter.value.rentalProperty,
                        "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => ((filter.value.rentalProperty) = $event)),
                        placeholder: "Объект аренды",
                        options: rentalPropertyOptions.value
                      }, null, 8, ["value", "options"])
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (hasFilterField('cluster'))
                ? (_openBlock(), _createBlock(_unref(AFormItem), {
                    key: 1,
                    label: "Кластер",
                    class: "stc-ant-field-skin"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(ASelect), {
                        value: filter.value.cluster,
                        "onUpdate:value": _cache[7] || (_cache[7] = ($event: any) => ((filter.value.cluster) = $event)),
                        placeholder: "Кластер",
                        options: clusterOptions.value
                      }, null, 8, ["value", "options"])
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (hasFilterField('educationType'))
                ? (_openBlock(), _createBlock(_unref(AFormItem), {
                    key: 2,
                    label: "Вид обр. деятельности",
                    class: "stc-ant-field-skin"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(ASelect), {
                        value: filter.value.educationType,
                        "onUpdate:value": _cache[8] || (_cache[8] = ($event: any) => ((filter.value.educationType) = $event)),
                        placeholder: "Вид обр. деятельности",
                        options: typeEducationOptions.value
                      }, null, 8, ["value", "options"])
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["open"])
  ], 64))
}
}

})